export default __webpack_public_path__ + "static/media/itembag_clothes.8be70135.png";